import { render } from "./SubmissionCode.vue?vue&type=template&id=f6ae5542&scoped=true"
import script from "./SubmissionCode.vue?vue&type=script&lang=js"
export * from "./SubmissionCode.vue?vue&type=script&lang=js"

import "./SubmissionCode.vue?vue&type=style&index=0&id=f6ae5542&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ae5542"]])

export default __exports__